import axiosInsAcademy from '@/api/axios-ugems-academy.js';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {

  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/completion/courses-hse', { params });
  },

  getCourseDetail(id, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/courses/${id}/batches-hse`, { params });
  },

  getCourseDetailFromCatalog(id) {
    return GET_COURSE_BY_ID(id);
  },

  getCompletionDetail(completionId) {
    return axiosInsAcademy.get(`/tna/partner/completion/${completionId}`);
  },

  submitCompletionReview(completionId, data) {
    return axiosInsAcademy.post(`/tna/partner/completion/${completionId}/review-by-hse`, data);
  },

  // Get batch participants with pagination, search, and filter (HSE)
  getBatchParticipants(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}/hse`, { params });
  },

  // Download batch report as Excel (HSE)
  downloadBatchReport(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}/hse/report`, {
      params,
      responseType: 'blob'
    });
  },

  // Download all certificates as zip
  downloadAllCertificates(batchId, params) {
    return axiosInsAcademy.get(`/tna/partner/completion/batches/${batchId}/hse/certificates`, {
      params,
      responseType: 'blob'
    });
  },

  getSummary(params = {}) {
    return axiosInsAcademy.get('/tna/hse/summary', { params });
  },

  approveCompletion(completionId) {
    return axiosInsAcademy.post(`/tna/partner/completion/${completionId}/approve`);
  },

  rejectCompletion(completionId) {
    return axiosInsAcademy.post(`/tna/partner/completion/${completionId}/reject`);
  }

};
